<script>
export default {
  name: 'TmlIdleRenderer',

  props: {
    timeout: {
      type: Number,
      default: 250,
    },
  },

  data() {
    return {
      shouldRender: false,
    };
  },

  created() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(
        () => {
          this.shouldRender = true;
        },
        {timeout: this.timeout}
      );
    } else {
      this.shouldRender = true;
    }
  },

  render() {
    return this.shouldRender ? this.$slots.default() : undefined;
  },
};
</script>
